module.exports = __webpack_public_path__ + "img/furniture.063f78a9.jpg";